import { RefObject, useEffect } from 'react';

type TypedMessageEvent<T> = Omit<MessageEvent, 'data'> & { data: T };

export const useMessageEventSubscription = <T>({
  listener,
  enabled,
  ref,
}: {
  listener: (event: TypedMessageEvent<T>) => void;
  enabled: boolean;
  ref?: RefObject<HTMLElement | HTMLIFrameElement> | null;
}) => {
  useEffect(() => {
    const handleReceiveMessage = (event: MessageEvent) => {
      const isSameSource =
        ref?.current instanceof HTMLIFrameElement
          ? event.source === ref?.current?.contentWindow
          : event.source === ref?.current;

      if (isSameSource) {
        listener(event);
      }
    };

    if (enabled) {
      window.addEventListener('message', handleReceiveMessage, false);
    }

    return () => {
      window.removeEventListener('message', handleReceiveMessage);
    };
  }, [enabled, listener, ref]);
};
